<template>
	<div
		id="originator-detail"
		:class="[!isWeb ? 'mobile-originator-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToOriginators()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Originador' : 'Editar Originador' }}
			</h1>
		</div>
		<OriginatorForm :isWeb="isWeb" />
		<div class="row column" v-if="$route.query.id">
			<OriginatorTab @handleTab="handleTab" />
			<OfferTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@orderByHeader="orderByHeader"
				v-show="selectedTab == 'offers'"
			/>
			<UsersTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@orderByHeader="orderByHeader"
				v-show="selectedTab == 'users'"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_OFFER_BY_ORIGINATOR,
	GET_ALL_USERS_BY_ORIGINATOR,
	GET_ORIGINATORS_STATUS,
} from '@/store/modules/originatorManagement/actions';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import OriginatorForm from '@/components/modules/Originator/OriginatorDetail/OriginatorForm/OriginatorForm.vue';
import OriginatorTab from '@/components/modules/Originator/OriginatorDetail/OriginatorTab/OriginatorTab.vue';
import OfferTable from '@/components/modules/Originator/OriginatorDetail/OfferTable/OfferTable.vue';
import UsersTable from '@/components/modules/Originator/OriginatorDetail/UsersTable/UsersTable.vue';

export default {
	name: 'OriginatorDetail',
	components: { SidebarArrow, OriginatorForm, OriginatorTab, OfferTable, UsersTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		headerSelected: null,
		orderSelected: null,
		selectedTab: 'offers',
	}),
	created() {
		this.getOriginatorsStatus({ vm: this });

		if (this.$route.query.id) {
			this.refreshOffers();
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('originatorManagement', {
			getOriginatorOffers: GET_OFFER_BY_ORIGINATOR,
			getOriginatorUsers: GET_ALL_USERS_BY_ORIGINATOR,
			getOriginatorsStatus: GET_ORIGINATORS_STATUS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		handleTab(param) {
			this.selectedTab = param;
			this.page = 1;
			this.headerSelected = null;
			this.orderSelected = null;
			this.refreshOffers();
		},
		goToOriginators() {
			this.$router.push({ path: '/dashboard/originators' });
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOffers();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshOffers();
		},
		refreshOffers() {
			const id = this.$route.query.id;
			let params = `?limit=20&page=${this.page}`;

			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			if (this.selectedTab == 'offers') {
				this.getOriginatorOffers({ vm: this, id: id, params: params });
			} else {
				const originatorName = this.originatorDetail.name;
				params = params.replace('?', '&');
				this.getOriginatorUsers({ vm: this, id: id, originator: originatorName, params: params });
			}
		},
	},
	computed: {
		...mapGetters('originatorManagement', ['originatorDetail']),
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OriginatorDetail.scss';
</style>
